export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/youtube-icon.5b23740f.svg","height":14,"width":18};